// extracted by mini-css-extract-plugin
export var componentWrapper = "Carousel-module--component-wrapper--1Tkej";
export var wrapper = "Carousel-module--wrapper--1sMkf";
export var wrapperGap = "Carousel-module--wrapper-gap--iW3c3";
export var wrapperFullwidth = "Carousel-module--wrapper-fullwidth--2Dv1A";
export var itemWrapper = "Carousel-module--item-wrapper--v9-ww";
export var item = "Carousel-module--item--1GBZ_";
export var radio = "Carousel-module--radio--2iki5";
export var radioOn = "Carousel-module--radio-on--d3zaM";
export var spinAround = "Carousel-module--spinAround--3NrlI";